export default __webpack_public_path__ + "static/media/08.64e76ba9.jpg";